// Invoice Configuration
export const INVOICE_CONFIG = {
  // Receipt Settings
  receipt: {
    width: '80mm', // Standard thermal receipt width
    fontSize: '12px',
    fontFamily: 'Courier New, monospace',
    logoPath: null, // Set to '/path/to/logo.png' to add logo
    showLogo: false
  },
  
  // Print Settings
  print: {
    autoPrint: true, // Auto-print in production
    devMode: process.env.NODE_ENV === 'development',
    previewOnly: false, // Set to true to disable auto-print
    windowSize: {
      width: 300,
      height: 600
    }
  },
  
  // Tax Settings
  tax: {
    enabled: false,
    rate: 0.08, // 8% tax rate
    name: 'Sales Tax'
  },
  
  // Payment Settings
  payment: {
    defaultMode: 'Cash',
    showCardNumber: false,
    cardNumberMask: '---- ---- ----'
  }
};

// Helper function to get receipt settings
export const getReceiptSettings = () => INVOICE_CONFIG.receipt;

// Helper function to get print settings
export const getPrintSettings = () => INVOICE_CONFIG.print;

// Helper function to calculate tax
export const calculateTax = (subtotal) => {
  if (!INVOICE_CONFIG.tax.enabled) return 0;
  return subtotal * INVOICE_CONFIG.tax.rate;
}; 